// import React, { useState, useEffect } from 'react';
// import { 
//   Table, 
//   TableBody, 
//   TableCell, 
//   TableContainer, 
//   TableHead, 
//   TableRow, 
//   Paper, 
//   Button, 
//   Dialog, 
//   DialogTitle, 
//   DialogContent, 
//   TextField,
//   Select,
//   MenuItem
// } from '@mui/material';
// import axios from 'axios';

// const StockManagementPage = () => {
//   const [products, setProducts] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);

//   // Fetch products
//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await axios.get('/api/all/products');
//         setProducts(response.data);
//       } catch (error) {
//         console.error('Error fetching products:', error);
//       }
//     };
//     fetchProducts();
//   }, []);

//   // Handle product edit
//   const handleEditProduct = async () => {
//     try {
//       await axios.put(`/api/all/products/${selectedProduct._id}`, selectedProduct);
//       // Refresh product list
//       const response = await axios.get('/api/all/products');
//       setProducts(response.data);
//       setOpenEditModal(false);
//     } catch (error) {
//       console.error('Error updating product:', error);
//     }
//   };

//   // Open edit modal
//   const openEditProductModal = (product) => {
//     setSelectedProduct({...product});
//     setOpenEditModal(true);
//   };

//   // Update size quantity
//   const updateSizeQuantity = (sizeIndex, quantity) => {
//     const updatedProduct = {...selectedProduct};
//     updatedProduct.size[sizeIndex].quantity = parseInt(quantity);
//     setSelectedProduct(updatedProduct);
//   };

//   return (
//     <div>
//       <h1>Stock Management</h1>
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Product Name</TableCell>
//               <TableCell>Category</TableCell>
//               <TableCell>Original Price</TableCell>
//               <TableCell>Sale Price</TableCell>
//               <TableCell>Total Inventory</TableCell>
//               <TableCell>Actions</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {products.map((product) => (
//               <TableRow key={product._id}>
//                 <TableCell>{product.productName}</TableCell>
//                 <TableCell>{product.categories[0].name}</TableCell>
//                 <TableCell>₹{product.originalPrice}</TableCell>
//                 <TableCell>₹{product.salePrice}</TableCell>
//                 <TableCell>
//                   {product.size.reduce((total, size) => total + size.quantity, 0)}
//                 </TableCell>
//                 <TableCell>
//                   <Button 
//                     variant="contained" 
//                     color="primary" 
//                     onClick={() => openEditProductModal(product)}
//                   >
//                     Edit Stock
//                   </Button>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Edit Product Modal */}
//       <Dialog 
//         open={openEditModal} 
//         onClose={() => setOpenEditModal(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>Edit Product Stock</DialogTitle>
//         <DialogContent>
//           {selectedProduct && (
//             <div>
//               <h2>{selectedProduct.productName}</h2>
//               <Table>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Size</TableCell>
//                     <TableCell>Current Quantity</TableCell>
//                     <TableCell>Update Quantity</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {selectedProduct.size.map((sizeItem, index) => (
//                     <TableRow key={sizeItem._id}>
//                       <TableCell>{sizeItem.size}</TableCell>
//                       <TableCell>{sizeItem.quantity}</TableCell>
//                       <TableCell>
//                         <TextField
//                           type="number"
//                           value={sizeItem.quantity}
//                           onChange={(e) => updateSizeQuantity(index, e.target.value)}
//                           variant="outlined"
//                           size="small"
//                         />
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
              
//               {/* Additional Product Details */}
//               <div style={{marginTop: '20px'}}>
//                 <TextField
//                   label="Original Price"
//                   value={selectedProduct.originalPrice}
//                   onChange={(e) => setSelectedProduct({
//                     ...selectedProduct, 
//                     originalPrice: parseFloat(e.target.value)
//                   })}
//                   fullWidth
//                   margin="normal"
//                   type="number"
//                 />
//                 <TextField
//                   label="Sale Price"
//                   value={selectedProduct.salePrice}
//                   onChange={(e) => setSelectedProduct({
//                     ...selectedProduct, 
//                     salePrice: parseFloat(e.target.value)
//                   })}
//                   fullWidth
//                   margin="normal"
//                   type="number"
//                 />
//               </div>

//               <Button 
//                 variant="contained" 
//                 color="primary" 
//                 onClick={handleEditProduct}
//                 style={{marginTop: '20px'}}
//               >
//                 Save Changes
//               </Button>
//             </div>
//           )}
//         </DialogContent>
//       </Dialog>
//     </div>
//   );
// };

// export default StockManagementPage;

// import React, { useState, useEffect } from 'react';
// import { 
//   Table, 
//   TableBody, 
//   TableCell, 
//   TableContainer, 
//   TableHead, 
//   TableRow, 
//   Paper, 
//   Button, 
//   Dialog, 
//   DialogTitle, 
//   DialogContent, 
//   TextField,
//   Select,
//   MenuItem,
//   Grid,
//   IconButton,
//   DialogActions
// } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';
// import axios from 'axios';

// const StockManagementPage = () => {
//   const [products, setProducts] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [openEditModal, setOpenEditModal] = useState(false);

//   // Fetch products
//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await axios.get('/api/all/products');
//         setProducts(response.data);
//       } catch (error) {
//         console.error('Error fetching products:', error);
//       }
//     };
//     fetchProducts();
//   }, []);

//   // Handle product edit
//   const handleEditProduct = async () => {
//     try {
//       // Calculate sale price based on original price and discount
//       const salePrice = selectedProduct.originalPrice * (1 - selectedProduct.discount / 100);
      
//       const updatedProductData = {
//         ...selectedProduct,
//         salePrice: Math.round(salePrice)
//       };

//       await axios.put(`/api/all/products/${selectedProduct._id}`, updatedProductData);
      
//       // Refresh product list
//       const response = await axios.get('/api/all/products');
//       setProducts(response.data);
//       setOpenEditModal(false);
//     } catch (error) {
//       console.error('Error updating product:', error);
//     }
//   };

//   // Open edit modal
//   const openEditProductModal = (product) => {
//     setSelectedProduct({...product});
//     setOpenEditModal(true);
//   };

//   // Update size quantity
//   const updateSizeQuantity = (sizeIndex, quantity) => {
//     const updatedProduct = {...selectedProduct};
//     updatedProduct.size[sizeIndex].quantity = parseInt(quantity);
//     setSelectedProduct(updatedProduct);
//   };

//   // Update delivery duration
//   const updateDeliveryDuration = (index, value) => {
//     const updatedProduct = {...selectedProduct};
//     updatedProduct.deliveryDuration[index] = parseInt(value);
//     setSelectedProduct(updatedProduct);
//   };

//   return (
//     <div style={{ padding: '20px' }}>
//       <h1>Stock Management</h1>
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Product Name</TableCell>
//               <TableCell>Category</TableCell>
//               <TableCell>Original Price</TableCell>
//               <TableCell>Discount (%)</TableCell>
//               <TableCell>Sale Price</TableCell>
//               <TableCell>Total Inventory</TableCell>
//               <TableCell>Actions</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {products.map((product) => (
//               <TableRow key={product._id}>
//                 <TableCell>{product.productName}</TableCell>
//                 <TableCell>{product.categories[0].name}</TableCell>
//                 <TableCell>₹{product.originalPrice}</TableCell>
//                 <TableCell>{product.discount}%</TableCell>
//                 <TableCell>₹{product.salePrice}</TableCell>
//                 <TableCell>
//                   {product.size.reduce((total, size) => total + size.quantity, 0)}
//                 </TableCell>
//                 <TableCell>
//                   <Button 
//                     variant="contained" 
//                     color="primary" 
//                     onClick={() => openEditProductModal(product)}
//                   >
//                     Edit Stock
//                   </Button>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Edit Product Modal */}
//       <Dialog 
//         open={openEditModal} 
//         onClose={() => setOpenEditModal(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           Edit Product Details
//           <IconButton 
//             onClick={() => setOpenEditModal(false)} 
//             style={{ position: 'absolute', right: 8, top: 8 }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           {selectedProduct && (
//             <Grid container spacing={3}>
//               <Grid item xs={12}>
//                 <TextField
//                   label="Product Name"
//                   fullWidth
//                   value={selectedProduct.productName}
//                   onChange={(e) => setSelectedProduct({
//                     ...selectedProduct, 
//                     productName: e.target.value
//                   })}
//                   margin="normal"
//                 />
//               </Grid>

//               <Grid item xs={6}>
//                 <TextField
//                   label="Original Price"
//                   type="number"
//                   fullWidth
//                   value={selectedProduct.originalPrice}
//                   onChange={(e) => setSelectedProduct({
//                     ...selectedProduct, 
//                     originalPrice: parseFloat(e.target.value)
//                   })}
//                   margin="normal"
//                 />
//               </Grid>

//               <Grid item xs={6}>
//                 <TextField
//                   label="Discount (%)"
//                   type="number"
//                   fullWidth
//                   value={selectedProduct.discount}
//                   onChange={(e) => setSelectedProduct({
//                     ...selectedProduct, 
//                     discount: parseFloat(e.target.value)
//                   })}
//                   margin="normal"
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <h3>Delivery Duration</h3>
//                 <Grid container spacing={2}>
//                   {selectedProduct.deliveryDuration.map((duration, index) => (
//                     <Grid item xs={2} key={index}>
//                       <TextField
//                         label={`Day ${index + 1}`}
//                         type="number"
//                         fullWidth
//                         value={duration}
//                         onChange={(e) => updateDeliveryDuration(index, e.target.value)}
//                         margin="normal"
//                       />
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Grid>

//               <Grid item xs={12}>
//                 <h3>Size Inventory</h3>
//                 <Table>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>Size</TableCell>
//                       <TableCell>Current Quantity</TableCell>
//                       <TableCell>Update Quantity</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {selectedProduct.size.map((sizeItem, index) => (
//                       <TableRow key={sizeItem._id}>
//                         <TableCell>{sizeItem.size}</TableCell>
//                         <TableCell>{sizeItem.quantity}</TableCell>
//                         <TableCell>
//                           <TextField
//                             type="number"
//                             value={sizeItem.quantity}
//                             onChange={(e) => updateSizeQuantity(index, e.target.value)}
//                             variant="outlined"
//                             size="small"
//                           />
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button 
//             onClick={() => setOpenEditModal(false)} 
//             color="secondary"
//           >
//             Cancel
//           </Button>
//           <Button 
//             variant="contained" 
//             color="primary" 
//             onClick={handleEditProduct}
//           >
//             Save Changes
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default StockManagementPage;


import React, { useState, useEffect  } from 'react';
 import { IoCloseSharp } from "react-icons/io5";
 import { BsMenuButtonWideFill } from "react-icons/bs";
import { useMemo } from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  TablePagination,
  Paper, 
  Button, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  TextField,
  Select,
  MenuItem,
  Grid,
  IconButton,
  DialogActions,
    ImageList,
  ImageListItem,
  Chip,
  FormControl,
  InputLabel,
  Box,
  Typography,
  Checkbox,
  FormControlLabel // Add this line
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import axios from 'axios';
import SideNavbaBarDashboard from '../SideNavaBarDashboard/SideNavbaBarDashboard';
import AdminHome from './AdminHome';
import { 
 
  LinearProgress,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {   Delete as DeleteIcon } from '@mui/icons-material';

const StockManagementPage = () => {

  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);

  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('/api/all/products');
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  // Handle product edit
  const handleEditProduct = async () => {
    try {
      // Calculate sale price based on original price and discount
 
      
      const updatedProductData = {
        ...selectedProduct,
     
      };

      await axios.put(`/api/all/products/${selectedProduct._id}`, updatedProductData);
      
      // Refresh product list
      const response = await axios.get('/api/all/products');
      setProducts(response.data);
      setOpenEditModal(false);
    } catch (error) {
      console.error('Error updating product:', error);
    }
  };
  const [availableStyles, setAvailableStyles] = useState([]);

  useEffect(() => {
    const fetchStyles = async () => {
      try {
        const response = await axios.get('/api/style-names');
        setAvailableStyles(response.data);
      } catch (error) {
        console.error('Error fetching styles:', error);
      }
    };
    fetchStyles();
  }, []);
  const handleDelete = async (productId) => {
    try {
      await axios.delete(`/api/products/${productId}`);
      setProducts(products.filter(product => product._id !== productId));
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };

  // Group styles by categoryType
  const groupedStyles = availableStyles.reduce((acc, style) => {
    if (!acc[style.categoryType]) {
      acc[style.categoryType] = [];
    }
    // Add just the style name
    acc[style.categoryType].push({
      styleName: style.styleName
    });
    return acc;
  }, {});

  // Check if a style is selected
  const isStyleSelected = (categoryType, styleName) => {
    return selectedProduct?.selectedStyles?.some(
      style => style.categoryType === categoryType && 
      style.selectedStyles.includes(styleName)
    );
  };

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return "/api/placeholder/48/48";
    const cleanUrl = imageUrl.trim();
    if (cleanUrl.startsWith('http')) return cleanUrl;
    const baseUrl = '';
    const imagePath = cleanUrl.startsWith('/') ? cleanUrl : `/${cleanUrl}`;
    return `${baseUrl}${imagePath}`;
  };

  const [uploadProgress, setUploadProgress] = useState(0);

  const handleImageUpload = async (event, productName) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);
    formData.append('productName', productName);

    try {
      const response = await axios.post(
        '/api/products/upload-image',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            setUploadProgress(progress);
          },
        }
      );

      if (response.data.url) {
        const newImage = {
          url: response.data.url,
          fileName: file.name,
          _id: response.data._id || Date.now().toString(),
        };

        setSelectedProduct(prev => ({
          ...prev,
          images: [...prev.images, newImage]
        }));
      }
      setUploadProgress(0);
    } catch (error) {
      console.error('Error uploading image:', error);
      setUploadProgress(0);
    }
  };

  const handleRemoveImage = async (imageId) => {
    try {
      await axios.delete(`/api/products/${selectedProduct._id}/images/${imageId}`);
      
      setSelectedProduct(prev => ({
        ...prev,
        images: prev.images.filter(img => img._id !== imageId)
      }));
    } catch (error) {
      console.error('Error removing image:', error);
    }
  };
  // Function to handle style selection/deselection
  const handleStyleSelection = (categoryType, categoryName) => {
    setSelectedProduct(prevProduct => {
      const updatedStyles = [...(prevProduct.selectedStyles || [])];
      const categoryIndex = updatedStyles.findIndex(cat => cat.categoryType === categoryType);
      
      if (categoryIndex === -1) {
        // Category doesn't exist, add new category with style
        updatedStyles.push({
          categoryType,
          selectedStyles: [categoryName]
        });
      } else {
        const currentCategory = updatedStyles[categoryIndex];
        const styleIndex = currentCategory.selectedStyles.indexOf(categoryName);
        
        if (styleIndex === -1) {
          // Add style to existing category
          currentCategory.selectedStyles.push(categoryName);
        } else {
          // Remove style from category
          currentCategory.selectedStyles = currentCategory.selectedStyles.filter(
            style => style !== categoryName
          );
          
          // If category is empty, remove it
          if (currentCategory.selectedStyles.length === 0) {
            updatedStyles.splice(categoryIndex, 1);
          }
        }
      }
      
      return {
        ...prevProduct,
        selectedStyles: updatedStyles
      };
    });
  };
  // Open edit modal
  const openEditProductModal = (product) => {
    setSelectedProduct({...product});
    setOpenEditModal(true);
  };
  // const getImageUrl = (imageUrl) => {
  //   if (!imageUrl) return "/api/placeholder/48/48";
  //   const cleanUrl = imageUrl.trim();
  //   if (cleanUrl.startsWith('http')) return cleanUrl;
  //   const baseUrl = '';
  //   const imagePath = cleanUrl.startsWith('/') ? cleanUrl : `/${cleanUrl}`;
  //   return `${baseUrl}${imagePath}`;
  // };

  // Update size quantity
  const updateSizeQuantity = (sizeIndex, quantity) => {
    const updatedProduct = {...selectedProduct};
    updatedProduct.size[sizeIndex].quantity = parseInt(quantity);
    setSelectedProduct(updatedProduct);
  };

  // Update delivery duration
  const updateDeliveryDuration = (index, value) => {
    const updatedProduct = {...selectedProduct};
    updatedProduct.deliveryDuration[index] = parseInt(value);
    setSelectedProduct(updatedProduct);
  };

  // Function to determine stock status
  const getStockStatus = (quantity) => {
    if (quantity > 0) {
      return { status: 'In Stock', color: 'success' };
    } else {
      return { status: 'Out of Stock', color: 'error' };
    }
  };
  const [searchProductId, setSearchProductId] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Extract unique categories
  const categories = useMemo(() => {
    const uniqueCategories = ['All', ...new Set(products.map(product => product.categories[0].name))];
    return uniqueCategories;
  }, [products]);

  // Filter and search logic
  const filteredProducts = useMemo(() => {
    return products.filter(product => {
      const matchesCategory = selectedCategory === 'All' || 
        product.categories[0].name === selectedCategory;
      
      const matchesSearch = product.productId.toString().includes(searchProductId.toLowerCase().toUpperCase());
      
      return matchesCategory && matchesSearch;
    });
  }, [products, selectedCategory, searchProductId]);


    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const handleChangePage = (event, newPage) => {
      setCurrentPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setCurrentPage(0); // Reset to the first page
    };
  
    // Paginated data
    const paginatedProducts = filteredProducts.slice(
      currentPage * rowsPerPage,
      currentPage * rowsPerPage + rowsPerPage
    );
  return (
<>
<div className="tf-page-title">
            <div className="container-full">
                <div className="heading text-center">Product Management</div>
            </div>
        </div>
        <section className="flat-spacing-11">
            <div className="container">
                    <div className="row">
                      <AdminHome/>
    <div className='col-lg-9'>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        {/* Product ID Search */}
        <TextField
          label="Search by Product ID"
          variant="outlined"
          value={searchProductId}
          onChange={(e) => setSearchProductId(e.target.value)}
          sx={{ flex: 1 }}
        />

        {/* Category Filter Dropdown */}
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Filter by Category</InputLabel>
          <Select
            value={selectedCategory}
            label="Filter by Category"
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            {categories.map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {/* <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Product ID</TableCell>
              <TableCell>Product Name</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Original Price</TableCell>
              <TableCell>Discount (%)</TableCell>
              <TableCell>Sale Price</TableCell>
              <TableCell>Total Inventory</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {paginatedProducts.map((product) => (
              <TableRow key={product._id}>
                <TableCell>{product.productId}</TableCell>
                <TableCell>{product.productName}</TableCell>
                <TableCell>{product.categories[0].name}</TableCell>
                <TableCell>₹{product.originalPrice}</TableCell>
                <TableCell>{product.discount}%</TableCell>
                <TableCell>₹{product.salePrice}</TableCell>
                <TableCell>
                  {product.size.reduce((total, size) => total + size.quantity, 0)}
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => openEditProductModal(product)}
                  >
                    Edit Stock
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
      <TableContainer component={Paper}>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell>Product Image</TableCell>
        <TableCell>Product ID</TableCell>
        <TableCell>Product Name</TableCell>
        <TableCell>Category</TableCell>
        <TableCell>Original Price</TableCell>
        <TableCell>Discount (%)</TableCell>
        <TableCell>Sale Price</TableCell>
        <TableCell>Total Inventory</TableCell>
        <TableCell>Actions</TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
  {paginatedProducts.map((product) => (
    <TableRow key={product._id}>
      <TableCell>
        {product.images && product.images[0]?.url ? (
          <img
            src={getImageUrl(product.images[0]?.url)}
            alt={product.productName}
            style={{ width: 100, height: 100, objectFit: "cover" }}
            onError={(e) => {
              console.error("Image failed to load:", product.images[0]?.url);
              e.target.src = "/api/placeholder/100/100"; // Fallback placeholder image
            }}
          />
        ) : (
          <div
            style={{
              width: 100,
              height: 100,
              backgroundColor: "#f0f0f0",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            No Image
          </div>
        )}
      </TableCell>
      <TableCell>{product.productId}</TableCell>
      <TableCell>{product.productName}</TableCell>
      <TableCell>{product.categories[0].name}</TableCell>
      <TableCell>₹{product.originalPrice}</TableCell>
      <TableCell>{product.discount}%</TableCell>
      <TableCell>₹{product.salePrice}</TableCell>
      <TableCell>
        {product.size.reduce((total, size) => total + size.quantity, 0)}
      </TableCell>
      <TableCell>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() => openEditProductModal(product)}
                              
                            >
                              Edit
                            </Button>
                            <IconButton
                              color="error"
                              onClick={() => handleDelete(product._id)}
                              size="small"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
    
    </TableRow>
  ))}
</TableBody>

  </Table>
</TableContainer>

      <TablePagination
          component="div"
          count={filteredProducts.length}
          page={currentPage}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 15]}
        />
    </Box>
      {/* <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Product Name</TableCell>
              <TableCell>Product ID</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Original Price</TableCell>
              <TableCell>Discount (%)</TableCell>
              <TableCell>Sale Price</TableCell>
              <TableCell>Total Inventory</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map((product) => (
              <TableRow key={product._id}>
                <TableCell>{product.productName}</TableCell>
                <TableCell>{product.productId}</TableCell>
                <TableCell>{product.categories[0].name}</TableCell>
                <TableCell>₹{product.originalPrice}</TableCell>
                <TableCell>{product.discount}%</TableCell>
                <TableCell>₹{product.salePrice}</TableCell>
                <TableCell>
                  {product.size.reduce((total, size) => total + size.quantity, 0)}
                </TableCell>
                <TableCell>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={() => openEditProductModal(product)}
                  >
                    Edit Stock
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}

      {/* Edit Product Modal */}
      {/* <Dialog 
        open={openEditModal} 
        onClose={() => setOpenEditModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Edit Product Details
          <IconButton 
            onClick={() => setOpenEditModal(false)} 
            style={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedProduct && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  label="Product Name"
                  fullWidth
                  value={selectedProduct.productName}
                  onChange={(e) => setSelectedProduct({
                    ...selectedProduct, 
                    productName: e.target.value
                  })}
                  margin="normal"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Original Price"
                  type="number"
                  fullWidth
                  value={selectedProduct.originalPrice}
                  onChange={(e) => setSelectedProduct({
                    ...selectedProduct, 
                    originalPrice: parseFloat(e.target.value)
                  })}
                  margin="normal"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Discount (%)"
                  type="number"
                  fullWidth
                  value={selectedProduct.discount}
                  onChange={(e) => setSelectedProduct({
                    ...selectedProduct, 
                    discount: parseFloat(e.target.value)
                  })}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Sale Price"
                  type="number"
                  fullWidth
                  value={selectedProduct.salePrice}
                  onChange={(e) => setSelectedProduct({
                    ...selectedProduct, 
                    
salePrice: parseFloat(e.target.value)
                  })}
                  margin="normal"
                />
              </Grid>

              <Grid item xs={12}>
              <DialogTitle>Delivery Duration</DialogTitle>
                <Grid container spacing={2}>
                  {selectedProduct.deliveryDuration.map((duration, index) => (
                    <Grid item 
                    xs={12} // Full width on extra small screens
                    sm={6}  // Half width on small screens
                    md={3}  // One-fourth width on medium screens
                    lg={2}  // One-sixth width on large screens
                     key={index}>
                      <TextField
                        label={`Day ${index + 1}`}
                        type="number"
                        fullWidth
                        value={duration}
                        onChange={(e) => updateDeliveryDuration(index, e.target.value)}
                        margin="normal"
                      />
                    </Grid>
                  ))}
                </Grid>


              </Grid>

              <Grid item xs={12}>
              <DialogTitle>Size Inventory</DialogTitle>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Size</TableCell>
                      <TableCell>Current Quantity</TableCell>
                      <TableCell>Update Quantity</TableCell>
                      <TableCell>Availability</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedProduct.size.map((sizeItem, index) => {
                      const stockStatus = getStockStatus(sizeItem.quantity);
                      return (
                        <TableRow key={sizeItem._id}>
                          <TableCell>{sizeItem.size}</TableCell>
                          <TableCell>{sizeItem.quantity}</TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              value={sizeItem.quantity}
                              onChange={(e) => updateSizeQuantity(index, e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Chip 
                              label={stockStatus.status} 
                              color={stockStatus.color} 
                              size="small" 
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenEditModal(false)} 
            color="secondary"
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleEditProduct}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog> */}
      {/* Edit Product Modal */}
<Dialog 
  open={openEditModal} 
  onClose={() => setOpenEditModal(false)}
  maxWidth="lg"
  fullWidth
>
  <DialogTitle>
    Edit Product Details
    <IconButton 
      onClick={() => setOpenEditModal(false)} 
      style={{ position: 'absolute', right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent>
    {selectedProduct && (
      <Grid container spacing={3}>
        {/* Basic Product Information */}
        <Grid item xs={12} md={6}>
          <TextField
            label="Product Name"
            fullWidth
            value={selectedProduct.productName}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              productName: e.target.value
            })}
            margin="normal"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Product ID"
            fullWidth
            value={selectedProduct.productId}
            disabled
            margin="normal"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Description"
            fullWidth
            multiline
            rows={4}
            value={selectedProduct.description}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              description: e.target.value
            })}
            margin="normal"
          />
        </Grid>

        {/* Pricing Information */}
        <Grid item xs={12} md={4}>
          <TextField
            label="Original Price"
            type="number"
            fullWidth
            value={selectedProduct.originalPrice}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              originalPrice: parseFloat(e.target.value)
            })}
            margin="normal"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="Discount (%)"
            type="number"
            fullWidth
            value={selectedProduct.discount}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              discount: parseFloat(e.target.value)
            })}
            margin="normal"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="Sale Price"
            type="number"
            fullWidth
            value={selectedProduct.salePrice}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              salePrice: parseFloat(e.target.value)
            })}
            margin="normal"
          />
        </Grid>

        {/* Product Details */}
        <Grid item xs={12} md={4}>
          <TextField
            label="Color"
            fullWidth
            value={selectedProduct.color}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              color: e.target.value
            })}
            margin="normal"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="Color Code"
            fullWidth
            value={selectedProduct.colorcode}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              colorcode: e.target.value
            })}
            margin="normal"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="Serial Number"
            fullWidth
            value={selectedProduct.serialNumber}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              serialNumber: e.target.value
            })}
            margin="normal"
          />
        </Grid>

        {/* Additional Details */}
        <Grid item xs={12} md={6}>
          <TextField
            label="Material"
            fullWidth
            value={selectedProduct.material}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              material: e.target.value
            })}
            margin="normal"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Brand Name"
            fullWidth
            value={selectedProduct.brandName}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              brandName: e.target.value
            })}
            margin="normal"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="HSN Code"
            fullWidth
            value={selectedProduct.hsn}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              hsn: e.target.value
            })}
            margin="normal"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="GST"
            fullWidth
            value={selectedProduct.gst}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              gst: e.target.value
            })}
            margin="normal"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="Packing Details"
            fullWidth
            value={selectedProduct.packingDetails}
            onChange={(e) => setSelectedProduct({
              ...selectedProduct, 
              packingDetails: e.target.value
            })}
            margin="normal"
          />
        </Grid>

        {/* Delivery Duration */}
        <Grid item xs={12}>
          <Typography variant="h6">Delivery Duration (Days)</Typography>
          <Grid container spacing={2}>
            {selectedProduct.deliveryDuration.map((duration, index) => (
              <Grid item xs={12} sm={4} md={2} key={index}>
                <TextField
                  label={`Day ${index + 1}`}
                  type="number"
                  fullWidth
                  value={duration}
                  onChange={(e) => updateDeliveryDuration(index, e.target.value)}
                  margin="normal"
                />
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Size and Inventory */}
        <Grid item xs={12}>
          <Typography variant="h6">Size Inventory</Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Size</TableCell>
                <TableCell>Size ID</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedProduct.size.map((sizeItem, index) => {
                const stockStatus = getStockStatus(sizeItem.quantity);
                return (
                  <TableRow key={sizeItem._id}>
                    <TableCell>{sizeItem.size}</TableCell>
                    <TableCell>{sizeItem.sizeId}</TableCell>
                    <TableCell>
                      <TextField
                        type="number"
                        value={sizeItem.quantity}
                        onChange={(e) => updateSizeQuantity(index, e.target.value)}
                        variant="outlined"
                        size="small"
                      />
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={stockStatus.status} 
                        color={stockStatus.color}
                        size="small" 
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Grid>

        {/* Selected Styles */}
        {/* <Grid item xs={12}>
          <Typography variant="h6">Selected Styles</Typography>
          {selectedProduct.selectedStyles?.map((styleCategory, index) => (
            <Box key={index} sx={{ mt: 2 }}>
              <Typography variant="subtitle1">{styleCategory.categoryType}</Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                {styleCategory.selectedStyles.map((style, styleIndex) => (
                  <Chip 
                    key={styleIndex}
                    label={style}
                    color="primary"
                    variant="outlined"
                  />
                ))}
              </Box>
            </Box>
          ))}
        </Grid> */}
        {/* Selected Styles */}
        <Grid item xs={12}>
      <Typography variant="h6" sx={{ mb: 2 }}>Available Styles</Typography>
      
      {Object.entries(groupedStyles).map(([categoryType, styles]) => (
        <Box key={categoryType} sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
            {categoryType}
          </Typography>
          
          <Box sx={{ 
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            p: 2,
            border: '1px solid #e0e0e0',
            borderRadius: 1
          }}>
            {styles.map(({ styleName }) => (
              <FormControlLabel
                key={`${categoryType}-${styleName}`}
                control={
                  <Checkbox
                    checked={isStyleSelected(categoryType, styleName)}
                    onChange={() => handleStyleSelection(categoryType, styleName)}
                  />
                }
                label={styleName}
              />
            ))}
          </Box>
        </Box>
      ))}

      {/* Selected Styles Preview */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>Selected Styles</Typography>
        {selectedProduct?.selectedStyles?.map((styleCategory, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography variant="subtitle1">{styleCategory.categoryType}</Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
              {styleCategory.selectedStyles.map((styleName, styleIndex) => (
                <Chip
                  key={styleIndex}
                  label={styleName}
                  onDelete={() => handleStyleSelection(styleCategory.categoryType, styleName)}
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Grid>

        {/* Images Preview */}
        <Grid item xs={12}>
          <Typography variant="h6">Product Images</Typography>
          {/* <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 1 }}>
            {selectedProduct.images?.map((image, index) => (
              <Box key={index}>
                <img
                  src={getImageUrl(image.url)}
                  alt={`Product ${index + 1}`}
                  style={{ width: 100, height: 100, objectFit: 'cover' }}
                />
              </Box>
            ))}
          </Box> */}
           <Box sx={{ mb: 2 }}>
        <input
          accept="image/*"
          style={{ display: 'none' }}
          id="raised-button-file"
          multiple
          type="file"
          onChange={(e) => handleImageUpload(e, selectedProduct.productName)}
        />
        <label htmlFor="raised-button-file">
          <Button
            variant="contained"
            component="span"
            startIcon={<CloudUploadIcon />}
          >
            Upload New Image
          </Button>
        </label>
        {uploadProgress > 0 && (
          <LinearProgress 
            variant="determinate" 
            value={uploadProgress} 
            sx={{ mt: 1 }}
          />
        )}
      </Box>

      <ImageList cols={3} gap={16} className="mt-4">
        {selectedProduct?.images.map((image, index) => (
          <ImageListItem 
            key={image._id || index}
            sx={{ position: 'relative' }}
          >
            <img
              src={getImageUrl(image.url)}
              alt={`Product ${index + 1}`}
              className="w-full h-32 object-cover rounded"
              onError={(e) => {
                console.error('Image failed to load:', image.url);
                e.target.src = "/api/placeholder/300/128";
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                bgcolor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '0 0 0 8px'
              }}
            >
              <IconButton
                size="small"
                onClick={() => handleRemoveImage(image._id)}
                sx={{ color: 'white' }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
            <Typography variant="caption" display="block" textAlign="center">
              {image.fileName}
            </Typography>
          </ImageListItem>
        ))}
      </ImageList>
        </Grid>
      </Grid>
    )}
  </DialogContent>
  <DialogActions>
    <Button 
      onClick={() => setOpenEditModal(false)} 
      color="secondary"
    >
      Cancel
    </Button>
    <Button 
      variant="contained" 
      color="primary" 
      onClick={handleEditProduct}
    >
      Save Changes
    </Button>
  </DialogActions>
</Dialog>
    </div>
    </div>
    </div>

    {/* <div className="btn-sidebar-account">
                <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                    <i className="icon icon-sidebar-2"></i>
                </button>
            </div> */}

            <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                <div className="canvas-wrapper">
                    <header className="canvas-header">
                        <span className="title">SIDEBAR ACCOUNT</span>
                        {/* <AdminHome /> */}
                        <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                    </header>
                    <div className="canvas-body sidebar-mobile-append"> </div>
                </div>
            </div>
    </section>
    
    <div className="btn-sidebar-account">
                          <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                              <BsMenuButtonWideFill />
                          </button>
                      </div>
          
                      <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                          <div className="canvas-wrapper">
                              <header className="canvas-header">
                                  <span className="title">SIDEBAR ACCOUNT</span>
                                  {/* <SideNavbaBarDashboard /> */}
                                  <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                              </header>
                              
                              <div className="canvas-body sidebar-mobile-append"> </div>
                          </div>
                      </div>
    
    </>
  );
};

export default StockManagementPage;